(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3253],{

/***/ 59685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ PRICING_PLAN; }
/* harmony export */ });
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71383);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68806);


var _templateObject;


var PRICING_PLAN = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  query pricingPlan($input: PricingPlanInput!) {\n    pricingPlan(input: $input) {\n      pricingInformation {\n        billingFeeGroup\n        amount\n        isDefault\n      }\n    }\n  }\n"])));

/***/ }),

/***/ 10712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69417);
/* harmony import */ var _API_member__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30940);
/* harmony import */ var _utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20253);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18459);
/* harmony import */ var _components_UserProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44979);
/* harmony import */ var _utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10239);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55252);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);


var _excluded = ["ctaLocation", "pageProperties", "partnerName", "marketingPath"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var _ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var BREEDLOVE_LOGIN_URL = publicRuntimeConfig.BREEDLOVE_LOGIN_URL,
    CORE_BASE_URL = publicRuntimeConfig.CORE_BASE_URL;

var CTAButton = function CTAButton(_ref2) {
  var _auth$member, _auth$member3;

  var ctaLocation = _ref2.ctaLocation,
      pageProperties = _ref2.pageProperties,
      partnerName = _ref2.partnerName,
      marketingPath = _ref2.marketingPath,
      props = (0,_usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, _excluded);

  var _useUserAuth = (0,_components_UserProvider__WEBPACK_IMPORTED_MODULE_5__/* .useUserAuth */ .Ii)(),
      auth = _useUserAuth.auth;

  var partnersRx = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getPartnersRXCookie */ .g)();
  var enrollmentUrl = partnerName ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .PARTNER_ENROLLMENT_IN_PROGRESS_URI */ .LE : _constants__WEBPACK_IMPORTED_MODULE_4__/* .ENROLLMENT_IN_PROGRESS_URI */ .TD;
  var buttonState = {
    [_API_member__WEBPACK_IMPORTED_MODULE_2__/* .AccountStatus.Pending */ .d.Pending]: {
      text: 'Continue registration',
      href: "".concat(CORE_BASE_URL).concat(enrollmentUrl)
    },
    [_API_member__WEBPACK_IMPORTED_MODULE_2__/* .AccountStatus.Submitted */ .d.Submitted]: {
      text: 'Approval pending',
      href: "".concat(CORE_BASE_URL).concat(enrollmentUrl)
    },
    [_API_member__WEBPACK_IMPORTED_MODULE_2__/* .AccountStatus.Client */ .d.Client]: {
      text: 'My account',
      href: BREEDLOVE_LOGIN_URL
    },
    [_API_member__WEBPACK_IMPORTED_MODULE_2__/* .AccountStatus.None */ .d.None]: {
      text: 'Get started',
      href: (0,_utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__/* .getEnrollmentUrl */ .JD)(undefined, partnersRx, marketingPath)
    },
    undefined: {
      text: 'Get started',
      href: (0,_utils_urlHelper__WEBPACK_IMPORTED_MODULE_3__/* .getEnrollmentUrl */ .JD)(undefined, partnersRx, marketingPath)
    }
  };

  var handleCtaClick = function handleCtaClick(ctaText) {
    (0,_utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_6__/* .logAnalyticsEvent */ .qw)({
      data: {
        cta_location: ctaLocation,
        cta_text: ctaText
      },
      name: _utils_AnalyticsHelper__WEBPACK_IMPORTED_MODULE_6__/* .AmplitudeEventName.ctaInteracted */ .LW.ctaInteracted,
      pageProperties: _objectSpread(_objectSpread({}, pageProperties), {}, {
        partnerName,
        marketingPath
      })
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    href: buttonState[auth === null || auth === void 0 ? void 0 : (_auth$member = auth.member) === null || _auth$member === void 0 ? void 0 : _auth$member.homepayAccountStatusV2].href,
    onClick: function onClick() {
      var _auth$member2;

      return handleCtaClick(buttonState[auth === null || auth === void 0 ? void 0 : (_auth$member2 = auth.member) === null || _auth$member2 === void 0 ? void 0 : _auth$member2.homepayAccountStatusV2].text);
    }
  }, props), {}, {
    children: buttonState[auth === null || auth === void 0 ? void 0 : (_auth$member3 = auth.member) === null || _auth$member3 === void 0 ? void 0 : _auth$member3.homepayAccountStatusV2].text
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (CTAButton);

/***/ }),

/***/ 47502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _CTAButton__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _CTAButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10712);


/***/ }),

/***/ 5409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Step_Step; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/shared/Step/Step.tsx



var Step = function Step(_ref) {
  var color = _ref.color,
      children = _ref.children,
      height = _ref.height,
      _ref$md = _ref.md,
      md = _ref$md === void 0 ? 4 : _ref$md,
      _ref$xs = _ref.xs,
      xs = _ref$xs === void 0 ? 12 : _ref$xs;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    item: true,
    xs: xs,
    md: md,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      borderRadius: "16px",
      bgcolor: color,
      height: height,
      py: 4,
      px: 2,
      textAlign: "center",
      children: children
    })
  });
};

/* harmony default export */ var Step_Step = (Step);
;// CONCATENATED MODULE: ./src/components/pages/shared/Step/index.ts


/***/ }),

/***/ 37289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ ModalVideo/* default */.Z; }
});

// UNUSED EXPORTS: FormSection

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/shared/FormSection/FormSection.tsx




var FormSection = function FormSection(_ref) {
  var children = _ref.children,
      sectionLabel = _ref.sectionLabel;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(Grid, {
      container: true,
      spacing: 4,
      children: [/*#__PURE__*/_jsx(Grid, {
        item: true,
        md: 4,
        xs: 12,
        children: /*#__PURE__*/_jsx(Typography, {
          textAlign: "left",
          component: "legend",
          children: sectionLabel
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        md: 8,
        xs: 12,
        children: children
      })]
    })
  });
};

/* harmony default export */ var FormSection_FormSection = ((/* unused pure expression or super */ null && (FormSection)));
// EXTERNAL MODULE: ./src/components/pages/shared/ModalVideo/ModalVideo.tsx
var ModalVideo = __webpack_require__(75652);
;// CONCATENATED MODULE: ./src/components/pages/shared/index.ts



/***/ }),

/***/ 33044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _marketingPath_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 1 modules
var Layout = __webpack_require__(35699);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/utils/usePartnerInfo.ts + 1 modules
var usePartnerInfo = __webpack_require__(5815);
// EXTERNAL MODULE: ./src/API/pricing.ts
var pricing = __webpack_require__(59685);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 9 modules
var ui = __webpack_require__(20935);
// EXTERNAL MODULE: ./src/utils/AnalyticsHelper.ts
var AnalyticsHelper = __webpack_require__(10239);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconLogoHomepaylogo.js
var IconLogoHomepaylogo = __webpack_require__(20074);
// EXTERNAL MODULE: ./src/components/Layout/Header/index.ts + 1 modules
var Header = __webpack_require__(29732);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/partners/Layout/Header.tsx







var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var PARTNERS_URL = publicRuntimeConfig.PARTNERS_URL,
    HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL;

var PartnersHeader = function PartnersHeader() {
  var isMobile = (0,useMediaQuery/* default */.Z)('(max-width: 974px)');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
    hidePhone: true,
    branding: {
      logo: /*#__PURE__*/(0,jsx_runtime.jsx)(IconLogoHomepaylogo/* default */.Z, {
        height: "58px",
        width: "200px"
      }),
      href: PARTNERS_URL
    },
    isMobile: isMobile,
    leftLinks: [{
      text: 'Home',
      href: PARTNERS_URL,
      type: 'link',
      isVisible: isMobile
    }, {
      text: 'Service & Pricing',
      href: "#service_pricing",
      type: 'link'
    }, {
      text: 'Service Guarantee',
      href: "#service_guarantee",
      type: 'link'
    }, {
      text: 'Benefits for Employees',
      href: "#benefits_for_employees",
      type: 'link'
    }, {
      text: 'ProPortal',
      href: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.proPortal.relativeURL */.ZY.proPortal.relativeURL),
      type: 'link'
    }],
    pageProperties: constants/* PAGE_PROPERTIES.partners */.vk.partners
  });
};

/* harmony default export */ var Layout_Header = (PartnersHeader);
;// CONCATENATED MODULE: ./src/components/pages/partners/Layout/index.ts

// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/images/partner-hero.png
/* harmony default export */ var partner_hero = ({"src":"/app/hp-vhp/_next/static/media/partner-hero.dfd2d1ff.png","height":444,"width":686,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAsElEQVR4nAGlAFr/Aaejof3z8vMCFRkYAB4dGwDl3NgABfv1AAwWHgAZJS7+AWNfWP8WCAcABxEYADQ7OgDDrKUAMTo5AD1JTwDx9foAAYJ5Z/8C8voA9/oMAPz/9wDgwpwAGTVQAGBydgAHCxQAAZSMgP/8/wgANTQ7AAD//ADf4uQAvK6iAF1aWgAdNUYAAZ2Yk/0eHycCEhUbAPr8+gDy6+kA2MzBAPrr4AA7VGX+8xpBghBtjisAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
// EXTERNAL MODULE: ./src/utils/urlHelper.ts
var urlHelper = __webpack_require__(20253);
// EXTERNAL MODULE: ./src/components/UserProvider/index.ts + 1 modules
var UserProvider = __webpack_require__(44979);
// EXTERNAL MODULE: ./src/API/member.ts
var member = __webpack_require__(30940);
// EXTERNAL MODULE: ./src/components/pages/shared/CTAButton/index.ts
var CTAButton = __webpack_require__(47502);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/Hero.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var Hero = function Hero(_ref) {
  var _auth$member;

  var partnerName = _ref.partnerName,
      marketingPath = _ref.marketingPath;
  var isMobile = (0,hooks/* useMobileQuery */.Lh)();

  var _useUserAuth = (0,UserProvider/* useUserAuth */.Ii)(),
      auth = _useUserAuth.auth;

  var handleButtonClick = function handleButtonClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Partners page',
        cta_text: 'Get started'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: _objectSpread(_objectSpread({}, constants/* PAGE_PROPERTIES.partners */.vk.partners), {}, {
        partnerName,
        marketingPath
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      alignItems: "center",
      sx: {
        marginTop: theme/* theme.spacing */.rS.spacing(5)
      },
      container: true,
      justifyContent: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        alignItems: "center",
        sx: {
          background: '#ffffff',
          borderRadius: '16px',
          boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.15)',
          gap: theme/* theme.spacing */.rS.spacing(2),
          marginRight: '-10%',
          padding: theme/* theme.spacing */.rS.spacing(4),
          zIndex: 1,
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('xl')]: {
            gap: theme/* theme.spacing */.rS.spacing(3)
          },
          [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
            padding: theme/* theme.spacing */.rS.spacing(2),
            margin: theme/* theme.spacing */.rS.spacing(0, 'auto'),
            width: '90%'
          }
        },
        container: true,
        direction: "column",
        item: true,
        md: 5,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          align: "center",
          variant: isMobile ? 'serifHeadline1' : 'serifDisplay3',
          children: [partnerName, " clients, welcome to HomePay!"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          align: "center",
          variant: "body1",
          fontSize: "20px",
          children: "We\u2019re a comprehensive tax and payroll service for busy home employers."
        }), (auth === null || auth === void 0 ? void 0 : (_auth$member = auth.member) === null || _auth$member === void 0 ? void 0 : _auth$member.homepayAccountStatusV2) === member/* AccountStatus.None */.d.None ? /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          fullWidth: true,
          color: "primary",
          href: (0,urlHelper/* getEnrollmentUrl */.JD)(undefined, undefined, marketingPath),
          onClick: handleButtonClick,
          size: isMobile ? 'medium' : 'large',
          variant: "contained",
          children: "Get started"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton/* default */.Z, {
          color: "primary",
          pageProperties: constants/* PAGE_PROPERTIES.partners */.vk.partners,
          size: isMobile ? 'medium' : 'large',
          variant: "contained",
          partnerName: partnerName,
          marketingPath: marketingPath
        })]
      }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        md: 8,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          objectFit: "contain",
          quality: 100,
          layout: "responsive",
          src: partner_hero,
          width: 686,
          height: 444,
          alt: "partner-hero"
        })
      })]
    })
  });
};

/* harmony default export */ var variant2_Hero = (Hero);
// EXTERNAL MODULE: ./src/components/pages/shared/Step/index.ts + 1 modules
var Step = __webpack_require__(5409);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/Tasks.tsx


function Tasks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Tasks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Tasks_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tasks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var CustomerService = function CustomerService(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Tasks_objectSpread(Tasks_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M42.73 23.93h-1.07v7.22h2.14v-7.22h-1.07Zm2.57 10.22h-1.183a10.26 10.26 0 0 1-10.137 8.74h-3.362a4.33 4.33 0 0 1-4.038 2.82 4.32 4.32 0 1 1 4.041-5.82h3.359a7.25 7.25 0 0 0 7.091-5.74h-.911a1.5 1.5 0 0 1-1.5-1.5V22.43a1.5 1.5 0 0 1 1.5-1.5h.999a17.42 17.42 0 0 0-5.139-10.85A16.34 16.34 0 0 0 24.18 5.3 16.81 16.81 0 0 0 7.81 20.93h1.03a1.5 1.5 0 0 1 1.5 1.5v10.22a1.5 1.5 0 0 1-1.5 1.5H3.7a1.5 1.5 0 0 1-1.5-1.5V22.43a1.5 1.5 0 0 1 1.5-1.5h1.105A19.82 19.82 0 0 1 24.12 2.3a19.32 19.32 0 0 1 14 5.64 20.45 20.45 0 0 1 6.048 12.99H45.3a1.5 1.5 0 0 1 1.5 1.5v10.22a1.5 1.5 0 0 1-1.5 1.5Zm-21.8-.03a3.512 3.512 0 0 0 2-.03 6 6 0 0 0 2-1.09l.26-.14c.62-.43 1.24-.91 1.85-1.43a32.62 32.62 0 0 0 3.24-3.14l.1-.1.055-.061c1.241-1.37 2.773-3.06 3.285-5.129a7 7 0 0 0-2.79-7.33 6.69 6.69 0 0 0-3.33-1.14 6.92 6.92 0 0 0-4.42 1.13c-.158.105-.308.218-.45.325l-.06.045-.29.22c-.043.027-.083.056-.124.084a2.14 2.14 0 0 1-.196.126h-.1l-.09-.05a3.687 3.687 0 0 1-.33-.21l-.29-.22c-.17-.13-.33-.25-.51-.37a6.88 6.88 0 0 0-4.42-1.13 6.69 6.69 0 0 0-3.39 1.19 7 7 0 0 0-2.78 7.28c.517 2.087 2.07 3.789 3.327 5.165l.023.025.09.1a34.013 34.013 0 0 0 3.24 3.15c.61.51 1.24.99 1.85 1.42l.25.19a6.12 6.12 0 0 0 2 1.12Zm-4.42-16.67h.33a4 4 0 0 1 2.21.63l.38.28.36.27c.199.145.406.278.62.4.126.068.256.128.39.18a2.999 2.999 0 0 0 2.31 0l.4-.19c.214-.122.421-.255.62-.4l.36-.27.38-.28a3.91 3.91 0 0 1 2.51-.62 3.7 3.7 0 0 1 1.9.66 4 4 0 0 1 1.56 4.13c-.335 1.34-1.533 2.66-2.601 3.836l-.049.054-.09.1a31.533 31.533 0 0 1-3 2.87c-.54.46-1.1.88-1.65 1.27l-.3.22c-.3.254-.637.46-1 .61a.75.75 0 0 1-.42 0 3.787 3.787 0 0 1-1-.62l-.29-.21a22.8 22.8 0 0 1-1.65-1.27 31.57 31.57 0 0 1-3-2.87l-.09-.1-.048-.053c-1.068-1.177-2.267-2.497-2.602-3.847a4 4 0 0 1 1.56-4.12 3.7 3.7 0 0 1 1.9-.66ZM5.2 31.15h2.14v-7.22H5.2v7.22Zm20.643 9.148a1.32 1.32 0 1 1 1.454 2.203 1.32 1.32 0 0 1-1.454-2.203Z",
      fill: "#213F5F"
    })
  }));
};

CustomerService.defaultProps = {
  width: "49",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Pay = function Pay(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Tasks_objectSpread(Tasks_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.72 19.66c.143.04.291.06.44.06a1.49 1.49 0 0 0 1.43-1.06 17 17 0 0 1 31.173-3.452L35.83 13.89a1.502 1.502 0 0 0-2.054 1.519 1.5 1.5 0 0 0 1.104 1.321l7.49 2.51c.151.052.31.079.47.08v-.01A1.5 1.5 0 0 0 44.33 18l1.17-8.32a1.513 1.513 0 0 0-3-.39l-.523 3.754A20.001 20.001 0 0 0 5.72 17.79a1.5 1.5 0 0 0 1 1.87ZM5.06 38.2a1.24 1.24 0 0 1-.33 0 1.503 1.503 0 0 1-1.13-1.83l1.9-8.2a1.5 1.5 0 0 1 2.07-1l7.22 3.19a1.499 1.499 0 0 1-.708 2.888 1.5 1.5 0 0 1-.582-.188l-3.717-1.65a17 17 0 0 0 31.327-.62 1.481 1.481 0 0 1 2-.82 1.51 1.51 0 0 1 .83 2 20 20 0 0 1-15 12.16c-1.214.22-2.446.331-3.68.33A20 20 0 0 1 7.355 33.31L6.5 37a1.49 1.49 0 0 1-1.44 1.2Zm18.39-4.63a5.584 5.584 0 0 1-.16-.05 9.3 9.3 0 0 1-3.82-3 1.506 1.506 0 0 1 2.25-2 6.872 6.872 0 0 0 2.53 2.11 2.92 2.92 0 0 0 2.37-.32 2.45 2.45 0 0 0 1.21-1.63l.001-.009c.072-.467.26-1.698-2.801-2.78-2-.7-5.19-1.85-5.58-4.9a4.471 4.471 0 0 1 1-3.46 6.42 6.42 0 0 1 3-1.97v-1.91a1.5 1.5 0 1 1 3 0v1.766c1.593.348 2.921 1.313 4.047 2.132l.043.031a1.52 1.52 0 0 1-.084 2.51 1.479 1.479 0 0 1-1.656-.06l-.014-.01c-1.202-.878-2.35-1.716-3.556-1.706a1.505 1.505 0 0 1-.33.025 3.39 3.39 0 0 0-2.08 1.121 1.502 1.502 0 0 0-.38 1.18c.15 1.22 2.21 2 3.57 2.44 4.53 1.61 5.1 4.22 4.79 6.12a5.42 5.42 0 0 1-2.62 3.71 6.162 6.162 0 0 1-1.73.715v2.105a1.5 1.5 0 0 1-3 0v-2.16Z",
      fill: "#213F5F"
    })
  }));
};

Pay.defaultProps = {
  width: "49",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var PencilPaper = function PencilPaper(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Tasks_objectSpread(Tasks_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m39.062 12.635-5.998-5.999a1.25 1.25 0 0 0-.884-.366H14.189a3.057 3.057 0 0 0-3.054 3.054v10.325l-.123-.123a3.2 3.2 0 0 0-4.52 0l-1.137 1.137a3.2 3.2 0 0 0 0 4.52l2.125 2.124 3.654 3.655v6.748a3.057 3.057 0 0 0 3.054 3.054h6.747l.986.986c.145.145.323.249.52.306l5.54 1.581a1.201 1.201 0 0 0 1.484-1.484l-.397-1.39h7.307a3.057 3.057 0 0 0 3.053-3.054v-24.19c0-.331-.132-.649-.366-.884Zm-6.233-2.698L35.79 12.9h-2.31a.654.654 0 0 1-.652-.653v-2.31Zm-8.594 26.206-2.261 2.262-8.557-8.558a1.238 1.238 0 0 0-.364-.364l-3.06-3.06 2.262-2.262 11.98 11.982Zm-.633 3.745 2.117-2.118.496 1.739v.003c0 .081.02.155.042.23l.018.066-.656.656-2.017-.576ZM7.054 22.359l1.137-1.137a.795.795 0 0 1 1.125 0l1.31 1.311-2.261 2.262-1.311-1.311a.795.795 0 0 1 0-1.125Zm7.136 15.902a.554.554 0 0 1-.554-.554v-4.248l4.8 4.801H14.19v.001Zm22.187 0h-8.02l-.471-1.65a1.212 1.212 0 0 0-.306-.52l-1.992-1.992h5.192a1.1 1.1 0 0 0 0-2.2h-7.391l-2.801-2.801H32.5a1.1 1.1 0 0 0 0-2.2H18.389l-4.753-4.753V9.321c0-.306.248-.554.554-.554h16.339v3.477a2.957 2.957 0 0 0 2.954 2.954h3.446v22.508a.554.554 0 0 1-.553.554v.001ZM32.5 21.9h-15a1.1 1.1 0 0 0 0 2.2h15a1.1 1.1 0 0 0 0-2.2Zm-15-5h15a1.1 1.1 0 1 1 0 2.2h-15a1.1 1.1 0 1 1 0-2.2Z",
      fill: "#213F5F"
    })
  }));
};

PencilPaper.defaultProps = {
  width: "48",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var PartnerTaskCards = function PartnerTaskCards() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    maxWidth: "lg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      mb: 3,
      textAlign: "center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "serifHeadline2",
        children: "HomePay takes time consuming tasks off your plate"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      spacing: 3,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Step/* default */.Z, {
        color: theme/* theme.palette.care.grey.50 */.rS.palette.care.grey[50],
        height: 260,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PencilPaper, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mt: 2,
          mb: 1,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "serifHeadline4",
            children: "Taxes"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body1",
          children: "We prepare your quarterly and year-end taxes - filed on-time, every time. Guaranteed."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Step/* default */.Z, {
        color: theme/* theme.palette.care.grey.50 */.rS.palette.care.grey[50],
        height: 260,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Pay, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mt: 2,
          mb: 1,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "serifHeadline4",
            children: "Payroll"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body1",
          children: "Set up a pay cadence that works for you, and we'll onboard your employees to save you time."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Step/* default */.Z, {
        color: theme/* theme.palette.care.grey.50 */.rS.palette.care.grey[50],
        height: 265,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomerService, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mt: 2,
          mb: 1,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "serifHeadline4",
            children: "HR support"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body1",
          children: "Contact our award-winning tax, payroll & HR specialists to have your questions answered quickly and accurately."
        })]
      })]
    })]
  });
};

/* harmony default export */ var Tasks = (PartnerTaskCards);
// EXTERNAL MODULE: ./src/components/pages/shared/index.ts + 1 modules
var shared = __webpack_require__(37289);
;// CONCATENATED MODULE: ./src/assets/images/partner-simplifies.jpg
/* harmony default export */ var partner_simplifies = ({"src":"/app/hp-vhp/_next/static/media/partner-simplifies.716a3db2.jpg","height":316,"width":489,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABgEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAKIQ/wD/xAAaEAEAAgMBAAAAAAAAAAAAAAADAQIABRKy/9oACAEBAAE/ANork7kazWkJxHrP/8QAGhEAAgIDAAAAAAAAAAAAAAAAAQIAAxEhkf/aAAgBAgEBPwBq1ODvpn//xAAYEQEBAAMAAAAAAAAAAAAAAAABAgAhkf/aAAgBAwEBPwCboaNcM//Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/partner-guarantee.jpg
/* harmony default export */ var partner_guarantee = ({"src":"/app/hp-vhp/_next/static/media/partner-guarantee.f9bba7fa.jpg","height":316,"width":489,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABQEBAQAAAAAAAAAAAAAAAAAAAAL/2gAMAwEAAhADEAAAAKop/8QAGxAAAwACAwAAAAAAAAAAAAAAAQIEAAMREjH/2gAIAQEAAT8AnooRpUbcW7LvLEgckq3uf//EABgRAAIDAAAAAAAAAAAAAAAAAAABAgMh/9oACAECAQE/AKknHT//xAAZEQACAwEAAAAAAAAAAAAAAAABEQACA1H/2gAIAQMBAT8A1KsFyf/Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/homepay-helps.jpg
/* harmony default export */ var homepay_helps = ({"src":"/app/hp-vhp/_next/static/media/homepay-helps.91e178ea.jpg","height":316,"width":489,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABQEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAAAtgL/xAAdEAACAQQDAAAAAAAAAAAAAAACAwQAARIUIjJC/9oACAEBAAE/AHi3SmJXIaq7ovcS5DiXmv/EABURAQEAAAAAAAAAAAAAAAAAAAAC/9oACAECAQE/AJf/xAAWEQADAAAAAAAAAAAAAAAAAAAAAUH/2gAIAQMBAT8AcP/Z","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoStarFilled.js
var Icon24InfoStarFilled = __webpack_require__(14144);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/Reviews.tsx







var Reviews = function Reviews() {
  var _theme$palette$care4;

  var renderReview = function renderReview(provider) {
    var _theme$palette$care, _theme$palette$care2, _theme$palette$care3;

    var review = constants/* SOCIAL_MEDIA_REVIEWS */.Bg[provider];
    var label = review.label,
        rating = review.rating,
        url = review.url;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      sx: {
        flex: '0 0 280px',
        display: 'flex',
        justifyContent: 'unset',
        paddingBottom: '15px',
        width: 'auto',
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
          justifyContent: 'center',
          paddingBottom: '0px',
          width: '330px'
        }
      },
      component: "span",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
          alignItems: 'center',
          display: 'flex',
          paddingRight: '10px'
        },
        component: "span",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            display: 'inline-flex',
            verticalAlign: 'sub'
          },
          component: "span",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon24InfoStarFilled/* default */.Z, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "display2",
        sx: {
          alignItems: 'center',
          color: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.white,
          display: 'flex',
          margin: theme/* theme.spacing */.rS.spacing(0, 1)
        },
        children: rating
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          paddingLeft: '10px'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body1",
          color: "white",
          children: label
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            textAlign: 'left',
            width: '100%'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
            sx: {
              color: (_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.yellow[500],
              fontSize: '16px',
              lineHeight: '26px',
              textDecoration: 'underline',
              '&:hover': {
                color: (_theme$palette$care3 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care3 === void 0 ? void 0 : _theme$palette$care3.yellow[500]
              }
            },
            "data-testid": "read-".concat(provider, "-reviews-link"),
            href: url,
            children: "Read more reviews"
          })
        })]
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    sx: {
      borderRadius: '0 0 24px 24px',
      backgroundColor: ((_theme$palette$care4 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care4 === void 0 ? void 0 : _theme$palette$care4.navy)[900],
      padding: theme/* theme.spacing */.rS.spacing(2),
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: theme/* theme.spacing */.rS.spacing(3),
      [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
        padding: theme/* theme.spacing */.rS.spacing(6)
      }
    },
    children: [renderReview('google'), renderReview('facebook')]
  });
};

/* harmony default export */ var variant2_Reviews = (Reviews);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/Testimonials.tsx


function Testimonials_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Testimonials_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Testimonials_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Testimonials_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var RatingStars = function RatingStars(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Testimonials_objectSpread(Testimonials_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "fill",
        x1: "0%",
        y1: "0%",
        x2: "100%",
        y2: "0%",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "50%",
          stopColor: "#FFC300"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "50%",
          stopColor: "#BCBCBC"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        id: "star",
        stroke: "none",
        d: "M4.619 3.546c.2-.554.2-.554.237-.568l.03-.17.68-1.875C5.772.365 6.093 0 6.556 0c.472 0 .79.377.984.96l.63 1.892.385 1.159 2.217.075.996.033c1.337.045 1.662 1.093.586 1.887l-.804.592-.803.592-.98.724.12.42c.137.475.16.55.206.757l.564 1.913c.23.802.018 1.486-.727 1.486-.28 0-.575-.124-.886-.347l-2.614-1.87-2.663 1.8c-.308.208-.598.323-.87.323-.76 0-.968-.697-.714-1.503l.302-.952.302-.952.37-1.163-.345-.268c-.464-.362-.464-.362-.312-.377h-.172l-.135-.106L.619 5.848c-1.054-.822-.7-1.86.636-1.87l.996-.006 2.219-.016.149-.411z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
      className: "star star-1",
      xlinkHref: "#star"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
      className: "star star-2",
      xlinkHref: "#star",
      transform: "translate(19)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
      className: "star star-3",
      xlinkHref: "#star",
      transform: "translate(38)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
      className: "star star-4",
      xlinkHref: "#star",
      transform: "translate(57)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
      className: "star star-5",
      xlinkHref: "#star",
      transform: "translate(76)"
    })]
  }));
};

RatingStars.defaultProps = {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlns: "http://www.w3.org/2000/svg",
  width: "89",
  height: "13"
};





var Testimonials = function Testimonials() {
  var _theme$palette$care, _theme$palette$care2;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        borderRadius: theme/* theme.spacing */.rS.spacing(3, 3, 0, 0),
        backgroundColor: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.grey[100],
        textAlign: 'center',
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
          padding: theme/* theme.spacing */.rS.spacing(5, 5, 0, 5)
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
          color: ((_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.navy)[900],
          height: 285,
          margin: '0 auto',
          padding: theme/* theme.spacing */.rS.spacing(2),
          textAlign: 'center',
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
            height: '235px',
            padding: '0 30px',
            width: '85%'
          },
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
            width: '600px'
          }
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            margin: '0 auto',
            top: '50%',
            transform: 'translateY(-50%)',
            position: 'relative',
            height: '100%'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Carousel */.lr, {
            children: constants/* PARTNER_PAGE_TESTIMONIALS.map */.ec.map(function (review) {
              var _theme$palette$care3;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
                "data-testid": "review-slide-".concat(review.id),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  variant: "serifHeadline2",
                  fontSize: [24, 28],
                  children: review.impression
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  variant: "body1",
                  marginY: 2,
                  children: review.body
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                  sx: {
                    '& svg': {
                      fill: (_theme$palette$care3 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care3 === void 0 ? void 0 : _theme$palette$care3.yellow[600]
                    },
                    margin: '10px auto 10px',
                    width: '90px'
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                      display: 'inline-flex',
                      verticalAlign: 'sub'
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(RatingStars, {})
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  variant: "caption",
                  children: review.author
                })]
              }, review.id);
            })
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(variant2_Reviews, {})]
  });
};

/* harmony default export */ var variant2_Testimonials = (Testimonials);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/Description.tsx














var Description = function Description() {
  var _useState = (0,react.useState)(false),
      isModalVisible = _useState[0],
      setModalVisibility = _useState[1];

  var handleModalVisibility = function handleModalVisibility() {
    setModalVisibility(function (visible) {
      return !visible;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            textAlign: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: partner_simplifies,
              width: 489,
              height: 316,
              alt: "family-image"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          md: 6,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "serifHeadline2",
            gutterBottom: true,
            children: "HomePay simplifies household employment"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            variant: "body1",
            gutterBottom: true,
            children: ["Household employers have some federal and state obligations that can feel overwhelming for busy families. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "The good news is paying legally is not difficult or as expensive as you think. HomePay handles all the compliance details and there are tax breaks that typically offset most of the employer taxes."]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          borderRadius: theme/* theme.spacing */.rS.spacing(2),
          backgroundColor: theme/* theme.palette.care.grey.50 */.rS.palette.care.grey[50],
          padding: theme/* theme.spacing */.rS.spacing(2),
          justifyContent: 'space-around',
          display: 'flex',
          gap: theme/* theme.spacing */.rS.spacing(2),
          alignItems: 'center',
          flexWrap: 'wrap',
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
            padding: theme/* theme.spacing */.rS.spacing(4)
          }
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          variant: "body1",
          sx: {
            paddingTop: theme/* theme.spacing */.rS.spacing(1)
          },
          children: ["Your loved one\u2019s care is your top priority.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Let HomePay take care of the rest."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          variant: "contained",
          color: "secondary",
          sx: {
            [theme/* theme.breakpoints.down */.rS.breakpoints.down('sm')]: {
              width: '100%',
              flex: '0 0 auto'
            }
          },
          onClick: handleModalVisibility,
          children: "See how"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(shared/* ModalVideo */.W, {
          dataTestId: "partners-how-homepay-works-modal",
          isVisible: isModalVisible,
          onClose: handleModalVisibility,
          title: "How HomePay works",
          videoUrl: constants/* HOW_HP_WORKS_PARTNERS_URL */.rU
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      id: "service_guarantee",
      sx: {
        scrollMarginTop: '140px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          md: 6,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            pb: 2,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              variant: "serifHeadline2",
              children: "Our happiness guarantee"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body1",
            gutterBottom: true,
            children: "If HomePay doesn\u2019t meet your expectations for an all-in-one nanny tax and payroll service during your first six months of use, we\u2019ll refund your payments for our services.*"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            pt: 2,
            pb: 2,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              variant: "serifHeadline2",
              children: "Our service guarantee"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body1",
            gutterBottom: true,
            children: "We guarantee that your tax returns are filed accurately and on time.**"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            textAlign: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: partner_guarantee,
              width: 489,
              height: 316,
              alt: "family-image"
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(variant2_Testimonials, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      id: "benefits_for_employees",
      sx: {
        scrollMarginTop: '140px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            textAlign: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: homepay_helps,
              width: 489,
              height: 316,
              alt: "family-image"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          md: 6,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "serifHeadline2",
            gutterBottom: true,
            children: "HomePay helps your nanny too"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body1",
            gutterBottom: true,
            children: "Nannies care for the most important people in your world: your loved ones. You can show your appreciation by paying legally, which can help your nanny qualify for benefits such as unemployment insurance, Social Security, and Medicare."
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var variant2_Description = (Description);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/PricingBanner.tsx


function PricingBanner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PricingBanner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PricingBanner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PricingBanner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var PricingBanner = function PricingBanner(_ref) {
  var _auth$member;

  var defaultPrice = _ref.defaultPrice,
      partnerName = _ref.partnerName,
      marketingPath = _ref.marketingPath;

  var _useUserAuth = (0,UserProvider/* useUserAuth */.Ii)(),
      auth = _useUserAuth.auth;

  var partnerPricingText = partnerName && defaultPrice !== 75 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
    variant: "body1",
    sx: {
      paddingTop: theme/* theme.spacing */.rS.spacing(1)
    },
    children: [partnerName, " Exclusive discount: ", /*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
      children: ["$", defaultPrice, " per month"]
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
    variant: "body1",
    sx: {
      paddingTop: theme/* theme.spacing */.rS.spacing(1)
    },
    children: [partnerName, " Exclusive discount: First month free! (", /*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
      children: ["$", defaultPrice, " value"]
    }), ")"]
  });

  var handleButtonClick = function handleButtonClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Partners page',
        cta_text: 'Get my discount'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: PricingBanner_objectSpread(PricingBanner_objectSpread({}, constants/* PAGE_PROPERTIES.partners */.vk.partners), {}, {
        partnerName,
        marketingPath
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          borderRadius: theme/* theme.spacing */.rS.spacing(2),
          backgroundColor: theme/* theme.palette.care.red.100 */.rS.palette.care.red[100],
          padding: theme/* theme.spacing */.rS.spacing(2),
          justifyContent: 'space-around',
          display: 'flex',
          gap: theme/* theme.spacing */.rS.spacing(2),
          alignItems: 'center',
          flexWrap: 'wrap',
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
            padding: theme/* theme.spacing */.rS.spacing(4)
          }
        },
        children: [partnerPricingText, (auth === null || auth === void 0 ? void 0 : (_auth$member = auth.member) === null || _auth$member === void 0 ? void 0 : _auth$member.homepayAccountStatusV2) === member/* AccountStatus.None */.d.None ? /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          variant: "contained",
          color: "primary",
          sx: {
            padding: 0,
            [theme/* theme.breakpoints.down */.rS.breakpoints.down('sm')]: {
              width: '100%',
              flex: '0 0 auto'
            }
          },
          href: (0,urlHelper/* getEnrollmentUrl */.JD)(undefined, undefined, marketingPath),
          onClick: handleButtonClick,
          children: "Get my discount"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton/* default */.Z, {
          sx: {
            padding: 0,
            width: '190px',
            [theme/* theme.breakpoints.down */.rS.breakpoints.down('sm')]: {
              width: '100%',
              flex: '0 0 auto'
            }
          },
          color: "primary",
          pageProperties: constants/* PAGE_PROPERTIES.partners */.vk.partners,
          variant: "contained",
          partnerName: partnerName,
          marketingPath: marketingPath
        })]
      })
    })
  });
};

/* harmony default export */ var variant2_PricingBanner = (PricingBanner);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/Modal.js + 17 modules
var Modal = __webpack_require__(27060);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityCheckmarkLarge.js
var Icon24UtilityCheckmarkLarge = __webpack_require__(54362);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/ServiceModal.tsx










var SERVICE_LIST = [{
  items: ['Prepare, file and remit federal and state taxes', 'Point of contact for state tax agencies', 'Manage official notices', 'Online access to archived tax records', 'Set up federal and state tax accounts', 'File required New Hire Report with tax agencies', 'Optional: Year-end tax preparation ($100)**'],
  serviceTitle: 'Tax processing'
}, {
  items: ["Calculate employee's withholdings and net pay", 'Automatic payroll processing on any device', 'Direct deposit each pay period', 'Track PTO accruals and other reimbursements', 'Online access to payroll records and paystubs'],
  serviceTitle: 'Payroll management'
}, {
  items: ['Unlimited phone, chat and email support', 'Unlimited support for your employee(s)', "Support if you're ever audited", 'Lifetime access to your payroll and tax records', 'On-board your employee(s) for you'],
  serviceTitle: 'Concierge support'
}];

var ModalServiceList = function ModalServiceList(_ref) {
  var _theme$palette$care;

  var defaultPrice = _ref.defaultPrice,
      isVisible = _ref.isVisible,
      title = _ref.title,
      onClose = _ref.onClose,
      partnerName = _ref.partnerName,
      marketingPath = _ref.marketingPath,
      isNoBilling = _ref.isNoBilling;
  var firstMonthFree = partnerName && defaultPrice === 75;

  var getListBoxes = function getListBoxes(itemList) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(List/* default */.Z, {
      children: itemList === null || itemList === void 0 ? void 0 : itemList.map(function (item, index) {
        var _careTheme$palette$ca;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
            component: "span",
            sx: {
              display: 'flex',
              padding: theme/* theme.spacing */.rS.spacing(0, 0, 0, 1.25)
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon24UtilityCheckmarkLarge/* default */.Z, {
              sx: {
                margin: theme/* theme.spacing */.rS.spacing(0.75, 0, 0, 0)
              },
              color: (_careTheme$palette$ca = theme/* theme.palette.care */.rS.palette.care) === null || _careTheme$palette$ca === void 0 ? void 0 : _careTheme$palette$ca.red[500],
              size: 16
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              color: "secondary",
              variant: "body2",
              sx: {
                marginTop: theme/* theme.spacing */.rS.spacing(0.5),
                marginLeft: theme/* theme.spacing */.rS.spacing(1)
              },
              children: item.includes('Optional') ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "Optional:"
                }), item.replace('Optional:', '')]
              }) : item
            })]
          })
        }, "list-".concat(index));
      })
    });
  };

  var getServiceList = function getServiceList() {
    return SERVICE_LIST === null || SERVICE_LIST === void 0 ? void 0 : SERVICE_LIST.map(function (_ref2, index) {
      var items = _ref2.items,
          serviceTitle = _ref2.serviceTitle;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        "data-testid": "service-item-".concat(index),
        md: 4,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          sx: {
            marginBottom: theme/* theme.spacing */.rS.spacing(3),
            [theme/* theme.breakpoints.down */.rS.breakpoints.down('lg')]: {
              marginTop: theme/* theme.spacing */.rS.spacing(2)
            }
          },
          variant: "h2",
          children: serviceTitle
        }), getListBoxes(items), index === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          mt: 2,
          pl: 1.25,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            color: "grey",
            variant: "body2",
            children: "** Includes Schedule H, Form 1040, Form W-2, Form W-3"
          })
        })]
      }, serviceTitle);
    });
  };

  var price = partnerName === undefined ? '$75' : "$".concat(defaultPrice);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    sx: {
      '& .MuiPaper-root': {
        width: {
          sm: '100%'
        },
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
          minWidth: '950px'
        },
        [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
          borderRadius: '24px',
          marginTop: theme/* theme.spacing */.rS.spacing(10),
          paddingBottom: theme/* theme.spacing */.rS.spacing(10)
        },
        paddingTop: theme/* theme.spacing */.rS.spacing(3)
      },
      '& .MuiTypography-h3': {
        fontFamily: 'Lora, serif',
        fontWeight: 400,
        fontSize: '28px'
      }
    },
    maxWidth: false,
    onClose: onClose,
    open: isVisible,
    title: title,
    variant: "dynamic",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      direction: "column",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          alignItems: 'center',
          alignSelf: 'center',
          backgroundColor: ((_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.latte)[50],
          borderRadius: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: theme/* theme.spacing */.rS.spacing(2),
          margin: theme/* theme.spacing */.rS.spacing(4, 0, 3, 0),
          padding: theme/* theme.spacing */.rS.spacing(3, 0),
          textAlign: 'center',
          width: '55%',
          [theme/* theme.breakpoints.down */.rS.breakpoints.down('lg')]: {
            width: '80%'
          }
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          children: !isNoBilling ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              sx: {
                margin: theme/* theme.spacing */.rS.spacing(0, 0.5, 0, 0)
              },
              variant: "display3",
              children: price
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
              variant: "h1",
              fontWeight: "400",
              children: "/month"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "h6",
            children: "Billed through partner"
          })
        }), firstMonthFree && /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body3",
          children: "First month free!"
        }), !isNoBilling && /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body3",
          children: "No setup fee"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton/* default */.Z, {
          sx: {
            width: '245px'
          },
          color: "primary",
          pageProperties: constants/* PAGE_PROPERTIES.partners */.vk.partners,
          variant: "contained",
          partnerName: partnerName,
          marketingPath: marketingPath
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        sx: {
          padding: theme/* theme.spacing */.rS.spacing(0, 2)
        },
        container: true,
        direction: "row",
        spacing: 1,
        children: getServiceList()
      })]
    })
  });
};

/* harmony default export */ var ServiceModal = (ModalServiceList);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/HeroNoPartner.tsx


function HeroNoPartner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HeroNoPartner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HeroNoPartner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HeroNoPartner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var HeroNoPartner_ref = config_default()(),
    HeroNoPartner_publicRuntimeConfig = HeroNoPartner_ref.publicRuntimeConfig;

var CORE_BASE_URL = HeroNoPartner_publicRuntimeConfig.CORE_BASE_URL,
    FOR_PARTNERS_URL = HeroNoPartner_publicRuntimeConfig.FOR_PARTNERS_URL;

var HeroNoPartner = function HeroNoPartner() {
  var theme = (0,useTheme/* default */.Z)();
  var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));

  var handleSignUpClick = function handleSignUpClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Partners page',
        cta_text: 'Get started'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: HeroNoPartner_objectSpread(HeroNoPartner_objectSpread({}, constants/* PAGE_PROPERTIES.partners */.vk.partners), {}, {
        partnerName: 'No partner'
      })
    });
  };

  var handlePartnershipClick = function handlePartnershipClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Partners page',
        cta_text: 'Partner with us'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: HeroNoPartner_objectSpread(HeroNoPartner_objectSpread({}, constants/* PAGE_PROPERTIES.partners */.vk.partners), {}, {
        partnerName: 'No partner'
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      alignItems: "center",
      sx: {
        marginTop: theme.spacing(5)
      },
      container: true,
      justifyContent: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        alignItems: "center",
        sx: {
          background: '#ffffff',
          borderRadius: '16px',
          boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.15)',
          gap: theme.spacing(2),
          marginRight: '-10%',
          padding: theme.spacing(4),
          zIndex: 1,
          [theme.breakpoints.up('xl')]: {
            gap: theme.spacing(3)
          },
          [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2),
            margin: theme.spacing(0, 'auto'),
            width: '90%'
          }
        },
        container: true,
        direction: "column",
        item: true,
        md: 6,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          align: "center",
          variant: isMobile ? 'serifHeadline1' : 'serifDisplay3',
          children: "Welcome to HomePay!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body1",
          fontSize: "20px",
          children: "Comprehensive tax and payroll services for busy home employers since 1992."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          sx: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-around',
            [theme.breakpoints.down('sm')]: {
              flexDirection: 'column',
              height: '90px'
            }
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            fullWidth: isMobile,
            color: "primary",
            href: "".concat(CORE_BASE_URL, "/app/hp-enrollment/signup"),
            onClick: handleSignUpClick,
            size: isMobile ? 'medium' : 'large',
            variant: "contained",
            children: "Get started"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            fullWidth: isMobile,
            color: "secondary",
            href: FOR_PARTNERS_URL,
            onClick: handlePartnershipClick,
            size: isMobile ? 'medium' : 'large',
            variant: "contained",
            children: "Partner with us"
          })]
        })]
      }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        md: 7,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          objectFit: "contain",
          quality: 100,
          layout: "responsive",
          src: partner_hero,
          width: 686,
          height: 444,
          alt: "partner-hero"
        })
      })]
    })
  });
};

/* harmony default export */ var variant2_HeroNoPartner = (HeroNoPartner);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/PartnerBanner/PartnerBanner.tsx







var PartnerBanner = function PartnerBanner() {
  var _theme$palette$care;

  var handlePhoneClick = function handlePhoneClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Partners - banner',
        cta_text: 'Call for a complimentary consultation'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: constants/* PAGE_PROPERTIES.partners */.vk.partners
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    sx: {
      alignItems: 'center',
      background: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.red[100],
      display: 'flex',
      justifyContent: 'center',
      minHeight: '41px',
      textAlign: 'center'
    },
    "data-testid": "partner-banner",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
      variant: "body3",
      children: ["Call for a complimentary consultation", /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          margin: theme/* theme.spacing */.rS.spacing(0, 0.5),
          fontWeight: 700
        },
        "data-testid": "phone-number-link",
        onClick: handlePhoneClick,
        href: "tel:877-367-1969",
        rel: "nofollow",
        underline: "none",
        children: "(877) 367-1969"
      })]
    })
  });
};

/* harmony default export */ var PartnerBanner_PartnerBanner = (PartnerBanner);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/PartnerBanner/index.ts

;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/Partner.tsx



function Partner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Partner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Partner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Partner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var Partner = function Partner() {
  var _data$pricingPlan$pri, _router$query$marketi3, _router$query$marketi4, _router$query$marketi5, _router$query$marketi6;

  var partnerInfo = (0,usePartnerInfo/* default */.Z)();
  var isNoBilling = Boolean((partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.pricingPlan) && constants/* PARTNER_NO_BILLING_PLANS.includes */.nv.includes(partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.pricingPlan));

  var _useLazyQuery = (0,useLazyQuery/* useLazyQuery */.t)(pricing/* PRICING_PLAN */.a),
      _useLazyQuery2 = (0,slicedToArray/* default */.Z)(_useLazyQuery, 2),
      fetchPricingInfo = _useLazyQuery2[0],
      _useLazyQuery2$ = _useLazyQuery2[1],
      data = _useLazyQuery2$.data,
      loading = _useLazyQuery2$.loading;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var handleClose = function handleClose() {
    return setIsVisible(false);
  };

  var handleOpen = function handleOpen() {
    var _router$query$marketi;

    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Partners',
        cta_text: 'View services and pricing'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: Partner_objectSpread(Partner_objectSpread({}, constants/* PAGE_PROPERTIES.partners */.vk.partners), {}, {
        partnerName: partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.name,
        marketingPath: (_router$query$marketi = router.query.marketingPath) === null || _router$query$marketi === void 0 ? void 0 : _router$query$marketi.toString()
      })
    });
    setIsVisible(true);
  };

  var defaultPrice = data === null || data === void 0 ? void 0 : (_data$pricingPlan$pri = data.pricingPlan.pricingInformation) === null || _data$pricingPlan$pri === void 0 ? void 0 : _data$pricingPlan$pri.filter(function (plane) {
    return plane.isDefault === true;
  });
  (0,react.useEffect)(function () {
    if (partnerInfo !== null && partnerInfo !== void 0 && partnerInfo.pricingPlan) {
      fetchPricingInfo({
        variables: {
          input: {
            pricingPlan: partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.pricingPlan
          }
        }
      });
    }
  }, [partnerInfo, fetchPricingInfo]);
  (0,react.useEffect)(function () {
    if (partnerInfo !== null && partnerInfo !== void 0 && partnerInfo.name) {
      var _router$query$marketi2;

      (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
        name: AnalyticsHelper/* AmplitudeEventName.screenViewed */.LW.screenViewed,
        pageProperties: Partner_objectSpread(Partner_objectSpread({}, constants/* PAGE_PROPERTIES.partners */.vk.partners), {}, {
          partnerName: partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.name,
          marketingPath: (_router$query$marketi2 = router.query.marketingPath) === null || _router$query$marketi2 === void 0 ? void 0 : _router$query$marketi2.toString()
        })
      });
    }

    if (!Object.prototype.hasOwnProperty.call(router.query, 'marketingPath')) {
      (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
        name: AnalyticsHelper/* AmplitudeEventName.screenViewed */.LW.screenViewed,
        pageProperties: constants/* PAGE_PROPERTIES.partners */.vk.partners
      });
    }
  }, [partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.name, router.query]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.Z, {
    HeaderComponent: Layout_Header,
    meta: constants/* META_PROPERTIES.partners */.b_.partners,
    pageProperties: Partner_objectSpread(Partner_objectSpread({}, constants/* PAGE_PROPERTIES.partners */.vk.partners), {}, {
      partnerName: partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.name,
      marketingPath: (_router$query$marketi3 = router.query.marketingPath) === null || _router$query$marketi3 === void 0 ? void 0 : _router$query$marketi3.toString()
    }),
    banner: /*#__PURE__*/(0,jsx_runtime.jsx)(PartnerBanner_PartnerBanner, {}),
    skipScreenViewed: true,
    children: [(partnerInfo !== null && partnerInfo !== void 0 ? partnerInfo : !Object.prototype.hasOwnProperty.call(router.query, 'marketingPath')) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      maxWidth: 1100,
      pb: 4,
      mx: "auto",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        gap: 6,
        container: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          children: partnerInfo !== null && partnerInfo !== void 0 && partnerInfo.name ? /*#__PURE__*/(0,jsx_runtime.jsx)(variant2_Hero, {
            partnerName: partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.name,
            marketingPath: (_router$query$marketi4 = router.query.marketingPath) === null || _router$query$marketi4 === void 0 ? void 0 : _router$query$marketi4.toString()
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(variant2_HeroNoPartner, {})
        }), (partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.name) && !isNoBilling && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(variant2_PricingBanner, {
            defaultPrice: defaultPrice === null || defaultPrice === void 0 ? void 0 : defaultPrice[0].amount,
            partnerName: partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.name,
            marketingPath: (_router$query$marketi5 = router.query.marketingPath) === null || _router$query$marketi5 === void 0 ? void 0 : _router$query$marketi5.toString()
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          id: "service_pricing",
          sx: {
            scrollMarginTop: '120px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tasks, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            my: 3,
            textAlign: "center",
            children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* LoadingSpinner */.TK, {
              "data-testId": "loading-spinner",
              inline: true
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              sx: {
                width: 275
              },
              color: "secondary",
              onClick: handleOpen,
              variant: "contained",
              children: "View services and pricing"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(variant2_Description, {})]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* LoadingSpinner */.TK, {
      "data-testId": "loading-spinner"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceModal, {
      defaultPrice: defaultPrice === null || defaultPrice === void 0 ? void 0 : defaultPrice[0].amount,
      isVisible: isVisible,
      title: "Services & Pricing",
      onClose: handleClose,
      partnerName: partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.name,
      marketingPath: (_router$query$marketi6 = router.query.marketingPath) === null || _router$query$marketi6 === void 0 ? void 0 : _router$query$marketi6.toString(),
      isNoBilling: isNoBilling
    })]
  });
};

/* harmony default export */ var variant2_Partner = (Partner);
;// CONCATENATED MODULE: ./src/components/pages/partners/variant2/index.ts

;// CONCATENATED MODULE: ./src/pages/partners/[[...marketingPath]].tsx



var PartnerPage = function PartnerPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(variant2_Partner, {});
};

/* harmony default export */ var _marketingPath_ = (PartnerPage);

/***/ }),

/***/ 32215:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[[...marketingPath]]",
      function () {
        return __webpack_require__(33044);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Icon24InfoStarFilled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53219);
/* harmony import */ var _utils_svgIconProps_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38423);
/* harmony import */ var _utils_generateStyles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46662);




/**
 * Icon24InfoStarFilled SVG icon component
 */
function Icon24InfoStarFilled(props) {
    const { sx, className } = props;
    const composedClassName = `${className !== null && className !== void 0 ? className : ''} Icon24InfoStarFilled`.trim();
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({ sx: [Object.assign({}, (0,_utils_generateStyles_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props)), ...(Array.isArray(sx) ? sx : [sx])], viewBox: "0 0 24 24" }, (0,_utils_svgIconProps_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Object.assign(Object.assign({}, props), { className: composedClassName }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#ffc415", d: "m15 8.2 5.56 1a.65.65 0 0 1 .35 1.1l-4.05 3.93 1 5.84a.59.59 0 0 1-.89.64L12 17.88l-5 2.74c-.44.27-1-.18-.88-.73l1-5.75L3.07 10a.66.66 0 0 1 .36-1.1L9 8.11 11.45 3a.66.66 0 0 1 1.15 0Z" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#ffc415", d: "M17.26 22a1.65 1.65 0 0 1-.71-.18l-4.5-2.65-4.58 2.46a1.41 1.41 0 0 1-1.59-.09A1.67 1.67 0 0 1 5.26 20l.88-5.3-3.7-3.7a1.58 1.58 0 0 1-.35-1.64 1.53 1.53 0 0 1 1.23-1.1l5.12-.73 2.29-4.66A1.43 1.43 0 0 1 12.05 2a1.66 1.66 0 0 1 1.33.82l2.29 4.66 5.12.91a1.45 1.45 0 0 1 1.14 1.1 1.46 1.46 0 0 1-.44 1.51l-3.7 3.56.88 5.44a1.67 1.67 0 0 1-.62 1.55.91.91 0 0 1-.79.45M12 17.25a.8.8 0 0 1 .45.09l4.45 2.56-.9-5.3a.93.93 0 0 1 .27-.82l3.61-3.56-5-.91a1.18 1.18 0 0 1-.62-.46L12 4.19 9.67 8.76a.69.69 0 0 1-.7.45L4 10.13l2.2 2.28 1.41 1.46a1.28 1.28 0 0 1 .27.82L7 19.9l4.5-2.47a.49.49 0 0 1 .5-.18" })));
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 54362:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Icon24UtilityCheckmarkLarge; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53219);
/* harmony import */ var _utils_svgIconProps_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38423);
/* harmony import */ var _utils_generateStyles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46662);




/**
 * Icon24UtilityCheckmarkLarge SVG icon component
 */
function Icon24UtilityCheckmarkLarge(props) {
    const { sx, className } = props;
    const composedClassName = `${className !== null && className !== void 0 ? className : ''} Icon24UtilityCheckmarkLarge`.trim();
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({ sx: [Object.assign({}, (0,_utils_generateStyles_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props)), ...(Array.isArray(sx) ? sx : [sx])], viewBox: "0 0 24 24" }, (0,_utils_svgIconProps_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Object.assign(Object.assign({}, props), { className: composedClassName }))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#172c42", d: "M8.89 19.1a1 1 0 0 1-.74-.33l-5.22-5.85A1 1 0 0 1 3 11.51a1 1 0 0 1 1.42.08l4.47 5L19.34 5.37a1 1 0 1 1 1.46 1.36L9.62 18.78a1 1 0 0 1-.73.32" })));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWNvbjI0VXRpbGl0eUNoZWNrbWFya0xhcmdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0ljb24yNFV0aWxpdHlDaGVja21hcmtMYXJnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBQzFCLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFDeEMsT0FBTyxZQUFZLE1BQU0seUJBQXlCLENBQUM7QUFDbkQsT0FBTyxjQUFjLE1BQU0sMkJBQTJCLENBQUM7QUFFdkQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsT0FBTyxVQUFVLDJCQUEyQixDQUFDLEtBQWdCO0lBQ2xFLE1BQU0sRUFBRSxFQUFFLEVBQUUsU0FBUyxFQUFFLEdBQUcsS0FBSyxDQUFDO0lBQ2hDLE1BQU0saUJBQWlCLEdBQUcsR0FBRyxTQUFTLGFBQVQsU0FBUyxjQUFULFNBQVMsR0FBSSxFQUFFLDhCQUE4QixDQUFDLElBQUksRUFBRSxDQUFDO0lBRWxGLE9BQU8sQ0FDTCxvQkFBQyxPQUFPLGtCQUFDLEVBQUUsRUFBRSxtQkFBTSxjQUFjLENBQUMsS0FBSyxDQUFDLEdBQUksR0FBRyxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsT0FBTyxFQUFDLFdBQVcsSUFBSyxZQUFZLGlDQUFLLEtBQUssS0FBRSxTQUFTLEVBQUUsaUJBQWlCLElBQUU7UUFDN0osOEJBQU0sSUFBSSxFQUFDLFNBQVMsRUFBQyxDQUFDLEVBQUMsK0lBQStJLEdBQUUsQ0FDaEssQ0FDWCxDQUFDO0FBQ0osQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBTdmdJY29uIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XG5pbXBvcnQgc3ZnSWNvblByb3BzIGZyb20gJy4vdXRpbHMvc3ZnSWNvblByb3BzLmpzJztcbmltcG9ydCBnZW5lcmF0ZVN0eWxlcyBmcm9tICcuL3V0aWxzL2dlbmVyYXRlU3R5bGVzLmpzJztcbmltcG9ydCB7IEljb25Qcm9wcyB9IGZyb20gJy4vdXRpbHMvdHlwZXMuanMnO1xuLyoqXG4gKiBJY29uMjRVdGlsaXR5Q2hlY2ttYXJrTGFyZ2UgU1ZHIGljb24gY29tcG9uZW50XG4gKi9cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIEljb24yNFV0aWxpdHlDaGVja21hcmtMYXJnZShwcm9wczogSWNvblByb3BzKSB7XG4gIGNvbnN0IHsgc3gsIGNsYXNzTmFtZSB9ID0gcHJvcHM7XG4gIGNvbnN0IGNvbXBvc2VkQ2xhc3NOYW1lID0gYCR7Y2xhc3NOYW1lID8/ICcnfSBJY29uMjRVdGlsaXR5Q2hlY2ttYXJrTGFyZ2VgLnRyaW0oKTtcblxuICByZXR1cm4gKFxuICAgIDxTdmdJY29uIHN4PXtbeyAuLi5nZW5lcmF0ZVN0eWxlcyhwcm9wcykgfSwgLi4uKEFycmF5LmlzQXJyYXkoc3gpID8gc3ggOiBbc3hdKV19IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4uc3ZnSWNvblByb3BzKHsuLi5wcm9wcywgY2xhc3NOYW1lOiBjb21wb3NlZENsYXNzTmFtZX0pfT5cbiAgICAgIDxwYXRoIGZpbGw9XCIjMTcyYzQyXCIgZD1cIk04Ljg5IDE5LjFhMSAxIDAgMCAxLS43NC0uMzNsLTUuMjItNS44NUExIDEgMCAwIDEgMyAxMS41MWExIDEgMCAwIDEgMS40Mi4wOGw0LjQ3IDVMMTkuMzQgNS4zN2ExIDEgMCAxIDEgMS40NiAxLjM2TDkuNjIgMTguNzhhMSAxIDAgMCAxLS43My4zMlwiLz57LyogZXNsaW50LWRpc2FibGUtbGluZSBwcmV0dGllci9wcmV0dGllciAqL31cbiAgICA8L1N2Z0ljb24+XG4gICk7XG59XG4iXX0=

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [611,5055,7423,3340,1614,7060,2004,1724,5699,1230,9774,2888,179], function() { return __webpack_exec__(32215); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);